export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/health_nutrition_fitness.03ed6dc.svg";